/**
 * Created by rickborst on 18/04/2017.
 */

import en from './en.json';
import iw from './iw.json';

export {en, iw};


// WEBPACK FOOTER //
// ./src/js/localisation/index.js